import tooltip from './tooltip'
import institutionMetadata from './institution'
import Status from './staff'
import productStatus from './product'

export default [...tooltip, ...institutionMetadata,...Status,...productStatus]
